module.exports = __webpack_public_path__ + "static/media/kouiKutushita1.81cbd575.png";